// Default background: brand gradient (per design system).
// tone prop is kept for backward compat but ignored — all avatars use gradient default.
const GRADIENT = 'linear-gradient(135deg, #3B4CCA 0%, #7C5CD3 100%)'

interface AvatarProps {
  name?: string
  size?: number
  /** @deprecated — all avatars now use the brand gradient */
  tone?: number
  style?: React.CSSProperties
  className?: string
}

export function Avatar({ name = '?', size = 24, style, className }: AvatarProps) {
  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: GRADIENT,
        color: '#ffffff',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: size * 0.42,
        fontWeight: 600,
        flexShrink: 0,
        ...style,
      }}
    >
      {name.slice(0, 1).toUpperCase()}
    </div>
  )
}

interface AvatarStackProps {
  names?: string[]
  size?: number
  max?: number
  className?: string
}

export function AvatarStack({ names = [], size = 22, max = 5, className }: AvatarStackProps) {
  const shown = names.slice(0, max)
  const extra = names.length - shown.length

  return (
    <div className={className} style={{ display: 'inline-flex' }}>
      {shown.map((n, i) => (
        <div key={i} style={{ marginLeft: i === 0 ? 0 : -size * 0.35, border: '2px solid var(--surface)', borderRadius: '50%' }}>
          <Avatar name={n} size={size} />
        </div>
      ))}
      {extra > 0 && (
        <div style={{
          marginLeft: -size * 0.35,
          border: '2px solid var(--surface)',
          borderRadius: '50%',
          width: size,
          height: size,
          background: 'var(--surface-2)',
          color: 'var(--ink-2)',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: size * 0.38,
          fontWeight: 600,
        }}>
          +{extra}
        </div>
      )}
    </div>
  )
}
